import * as Yup from "yup";

const newCategoryFormValidationSchema = Yup.object().shape({
  name: Yup.string().required("Category Name is Required"),
  vtex_description: Yup.string().required("Description is Required"),
  // parent_id: Yup.string().required("Parent Category is Required"),
  vtex_commission: Yup.string().required("VTEX Commission is Required"),
  vtexAdminId: Yup.string().required("VTEX Admin ID is Required"),
  global_category_id: Yup.string().required("Global Category ID is Required"),
});


export default newCategoryFormValidationSchema;
